module.exports = __webpack_public_path__ + "img/chat-new-wht.a8186315.svg";